export const colorGrey300 = "#818b99";
export const colorGrey400 = "#667180";
export const colorGrey500 = "#444d59";
export const colorGrey600 = "#252b33";
export const colorGreyBase = "#444d59";
export const colorNeutral300 = "#ffffff";
export const colorNeutral400 = "#f5f5f5";
export const colorNeutral500 = "#e5e5e5";
export const colorNeutral600 = "#cccccc";
export const colorNeutralBase = "#e5e5e5";
export const colorPurple300 = "#edd9ff";
export const colorPurple400 = "#b061f2";
export const colorPurple500 = "#7a04dd";
export const colorPurple600 = "#540099";
export const colorPurple700 = "#380066";
export const colorPurpleBase = "#7a04dd";
export const colorBlue300 = "#e5f0ff";
export const colorBlue400 = "#6192f2";
export const colorBlue500 = "#1667d9";
export const colorBlue600 = "#003499";
export const colorBlue700 = "#002266";
export const colorBlueBase = "#1667d9";
export const colorRed300 = "#ffd9dc";
export const colorRed400 = "#f2616d";
export const colorRed500 = "#cc1f2d";
export const colorRed600 = "#73000a";
export const colorRedBase = "#cc1f2d";
export const colorOrange300 = "#ffe6d9";
export const colorOrange400 = "#ff884c";
export const colorOrange500 = "#f25100";
export const colorOrange600 = "#bf4000";
export const colorOrangeBase = "#f25100";
export const colorGreen300 = "#cef2dd";
export const colorGreen400 = "#42a66c";
export const colorGreen500 = "#0d803d";
export const colorGreen600 = "#00401b";
export const colorGreenBase = "#0d803d";
export const colorWhite = "#ffffff";